/* dn-cart.js — Warenkorb im neuen Design (Klasse dn-cart-v2).

   Aufgaben:
     1. Plus-Knoepfe der Upsell-Karussells
     2. Empfehlungen fuer die Karussells — erst beim ersten Oeffnen des Drawers
     3. Leiste und Geschenkzeilen beim Oeffnen abgleichen (ohne Anfrage)
   Warum nachladen: der Drawer wird auf jeder Seite mitgerendert. Der Abruf der
   Empfehlungen kostete rund 970 ms Serverzeit pro Seitenaufruf, auch wenn den
   Warenkorb niemand aufmachte. Jetzt passiert er beim Oeffnen. */
(function () {
  if (window.dnCartReady) return;
  window.dnCartReady = true;

  var speicher = {};
  var geoeffnet = false;
  /* Saat merken, damit nicht jede Warenkorb-Aenderung die Karussells neu holt (gemessen 733 ms,
     die Karten springen). Aber (Roman, 2026-09-11): liegt die gemerkte Saat nicht mehr im Warenkorb
     oder haben sich die Produktlinien geaendert (Gel Strips raus, Press Ons rein), muss neu geholt
     werden - sonst standen Gel-Strips-Designs unter einem Press-Ons-Warenkorb. Das Element traegt dafuer
     data-dn-items (Produkt-IDs im Warenkorb) und data-dn-lines (Linien, EU). */
  var gemerkteSaat = null;
  var gemerkteLinien = null;
  /* Varianten, die ueber die Plus-Knoepfe dazukamen — ihre Karten fliegen aus
     den Karussells, weil die zwischengespeicherte Fassung sie noch kennt. */
  var eigeneZugaben = {};

  function kartenAufraeumen(wurzel, imKorb) {
    if (!wurzel) return;
    Object.keys(eigeneZugaben).forEach(function (variante) {
      var knopf = wurzel.querySelector('.dn-ups__add[data-dn-add="' + variante + '"]');
      var karte = knopf && knopf.closest ? knopf.closest('.dn-ups__card') : null;
      if (karte) karte.remove();
    });
    /* Karten von Produkten, die inzwischen im Warenkorb liegen (auch von der Produktseite dazugelegt) */
    if (imKorb) {
      var karten = wurzel.querySelectorAll('.dn-ups__card[data-dn-produkt]');
      for (var i = 0; i < karten.length; i++) {
        if (imKorb.indexOf(',' + karten[i].getAttribute('data-dn-produkt') + ',') !== -1) karten[i].remove();
      }
    }
    /* Reihe ohne Karten weg, sonst steht eine Ueberschrift ueber nichts */
    var reihen = wurzel.querySelectorAll('.dn-ups');
    for (var r = 0; r < reihen.length; r++) {
      if (!reihen[r].querySelector('.dn-ups__card')) reihen[r].remove();
    }
  }

  function holen(schluessel, url) {
    if (!speicher[schluessel]) {
      speicher[schluessel] = fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return speicher[schluessel];
  }

  /* ---------- 2) Empfehlungen fuer die zwei Karussells ---------- */
  class DnCartUpsells extends HTMLElement {
    connectedCallback() { if (geoeffnet) this.laden(); }

    laden() {
      if (this.dataset.dnGeholt) return;
      var abschnitt = this.getAttribute('section-id');
      var saatNeu = this.getAttribute('product-id');
      var linien = this.getAttribute('data-dn-lines') || '';
      var imKorb = this.getAttribute('data-dn-items') || '';
      /* gemerkte Saat nur weiterverwenden, wenn sie noch im Warenkorb liegt und die Linien gleich sind */
      var produkt = saatNeu;
      if (gemerkteSaat && linien === gemerkteLinien && imKorb.indexOf(',' + gemerkteSaat + ',') !== -1) produkt = gemerkteSaat;
      if (!produkt || !abschnitt) return;
      gemerkteSaat = produkt;
      gemerkteLinien = linien;

      var basis = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.productRecommendationsUrl) || '/recommendations/products';
      var selbst = this;
      this.dataset.dnGeholt = 'laeuft';

      var url = basis + '?product_id=' + produkt + '&limit=16&intent=related&section_id=' + abschnitt;
      /* Zwischenspeicher je Saat UND Linien: dieselbe Saat mit neuer Linie im Warenkorb braucht neue Reihen */
      holen(url + '|' + linien, url).then(function (html) {
        if (!html) { selbst.dataset.dnGeholt = ''; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var neu = tmp.querySelector('dn-cart-upsells');
        if (!neu) { selbst.dataset.dnGeholt = ''; return; }
        selbst.innerHTML = neu.innerHTML;
        kartenAufraeumen(selbst, imKorb);
        selbst.dataset.dnGeholt = 'ja';
      });
    }
  }

  window.customElements.define('dn-cart-upsells', DnCartUpsells);

  function nachladen() {
    if (!geoeffnet) return;
    var offen = document.querySelectorAll('#mini-cart dn-cart-upsells');
    for (var i = 0; i < offen.length; i++) {
      if (typeof offen[i].laden === 'function') offen[i].laden();
    }
  }

  /* ---------- 3) Leiste und Geschenkzeilen beim Oeffnen abgleichen ----------
     Ohne Anfrage, nur aus dem Markup: Steht eine Geschenk-Stufe auf "erreicht",
     muss ihre Zeile da sein — und umgekehrt. Passt es nicht, laeuft die
     Geschenk-Automatik (assets/theme.js). Das faengt Warenkoerbe auf, deren
     Aenderung kein cart:updated gefeuert hat (Fremd-Skripte, /discount-Links,
     Sitzungen mit einem stehen gebliebenen Geschenk aus einer alten Fassung). */
  var warOffen = false;

  function geschenkeAbgleichen() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || typeof window.cartUpdateGiftAddFun !== 'function') return;
    var leiste = drawer.querySelector('free-shipping-bar.freegift_present');
    if (!leiste) return;
    var ware = parseFloat(leiste.getAttribute('cart-total'));
    if (isNaN(ware)) return;

    var stufen = [
      [leiste.getAttribute('data-free-gift'), parseFloat(leiste.getAttribute('freegift-threshold'))],
      [leiste.getAttribute('data-free-gift-two'), parseFloat(leiste.getAttribute('freegift-threshold-two'))]
    ];
    var erlaubt = [];
    var passt = true;

    stufen.forEach(function (stufe) {
      var variante = stufe[0], schwelle = stufe[1];
      if (!variante || isNaN(schwelle)) return;
      erlaubt.push(variante);
      var zeileDa = !!drawer.querySelector('line-item.dn-gift[data-key^="' + variante + ':"]');
      if ((ware >= schwelle) !== zeileDa) passt = false;
    });
    /* Bonus-Geschenke aus Rabattcodes gehoeren der Automatik ebenfalls, aber ohne Schwelle */
    var bonus = drawer.querySelectorAll('.bonus_gift_code_input');
    for (var b = 0; b < bonus.length; b++) if (bonus[b].value) erlaubt.push(bonus[b].value);

    /* Geschenkzeile, die zu keiner Stufe (mehr) gehoert */
    var zeilen = drawer.querySelectorAll('line-item.dn-gift[data-key]');
    for (var z = 0; z < zeilen.length; z++) {
      var variante = (zeilen[z].getAttribute('data-key') || '').split(':')[0];
      if (erlaubt.indexOf(variante) === -1) passt = false;
    }

    if (!passt) window.cartUpdateGiftAddFun();
  }

  function drawerIstOffen() {
    geoeffnet = true;
    nachladen();
    if (!warOffen) {
      warOffen = true;
      geschenkeAbgleichen();
    }
  }

  /* Oeffnen erkennen: Klick auf einen Warenkorb-Umschalter … */
  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    if (ziel && ziel.closest && ziel.closest('[aria-controls="mini-cart"]')) {
      window.setTimeout(drawerIstOffen, 60);
    }
  }, true);

  /* … oder das open-Attribut am Drawer, etwa wenn er nach Add-to-Cart aufgeht */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var drawer = document.getElementById('mini-cart');
      if (!drawer) return;
      if (drawer.hasAttribute('open')) drawerIstOffen();
      else warOffen = false;
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /* Nach dem Neuzeichnen ruft der neue <dn-cart-upsells> sich selbst auf
     (connectedCallback). Der Griff hier ist nur das Netz fuer Neuaufbauten,
     die das Element stehen lassen — kurz danach, nicht erst nach einer halben
     Sekunde, sonst stehen die Karussells solange leer da. */
  document.documentElement.addEventListener('cart:updated', function () {
    window.setTimeout(nachladen, 150);
  });

  /* ---------- 1) Plus-Knoepfe ---------- */
  var laeuft = false;

  function drawerNeuZeichnen() {
    var meine = window.dnCartRenderAnfrage = (window.dnCartRenderAnfrage || 0) + 1;
    return fetch('/?section_id=mini-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* eine neuere Anfrage laeuft schon - diese Antwort ist alt und darf
           den frischeren Stand nicht ueberschreiben */
        if (meine !== window.dnCartRenderAnfrage) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var alt = document.querySelector('#mini-cart');
        var neu = tmp.querySelector('#mini-cart');
        if (alt && neu) {
          /* frischer Stand: ein noch wartendes Neuzeichnen des Themes darf nicht mehr darueber */
          window.dnCartRenderVersion = (window.dnCartRenderVersion || 0) + 1;
          alt.innerHTML = neu.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest ? ereignis.target.closest('.dn-ups__add') : null;
    if (!knopf) return;
    if (!knopf.closest('.dn-cart-v2')) return;

    ereignis.preventDefault();
    if (laeuft) return;

    var variante = knopf.getAttribute('data-dn-add');
    if (!variante) return;

    laeuft = true;
    knopf.classList.add('is-busy');
    var spinner = knopf.querySelector('.dn-ups__spinner');
    if (spinner) spinner.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(window.DnAtcSource ? window.DnAtcSource.stamp({ id: Number(variante), quantity: 1 }, knopf) : { id: Number(variante), quantity: 1 })
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('add.js ' + antwort.status);
        eigeneZugaben[variante] = true;
        return drawerNeuZeichnen();
      })
      .then(function () {
        kartenAufraeumen(document.querySelector('#mini-cart'));
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (warenkorb) {
        /* dasselbe Ereignis wie das Theme: haengt Zaehler, Geschenk-Automatik und Apps an */
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: warenkorb }
        }));
      })
      .catch(function (fehler) {
        console.error('Upsell konnte nicht hinzugefuegt werden:', fehler);
        knopf.classList.remove('is-busy');
        if (spinner) spinner.hidden = true;
      })
      .finally(function () {
        laeuft = false;
      });
  });
})();

/* ------------------------------------------------------------------
   Schatten unter der Kopfzeile, sobald der Inhalt gescrollt ist —
   dann ist die Fortschrittsleiste weg und der Kopf braucht eine Kante.
   Ein Zuhoerer in der Capture-Phase: scroll blubbert nicht, wird aber
   erfasst, und so ueberlebt er jedes Neuzeichnen des Drawers.
   ------------------------------------------------------------------ */
(function () {
  function pruefen(bereich) {
    var drawer = bereich.closest('.dn-cart-v2');
    if (!drawer) return;
    drawer.classList.toggle('dn-scrolled', bereich.scrollTop > 4);
  }

  document.addEventListener('scroll', function (ereignis) {
    var ziel = ereignis.target;
    if (!ziel || !ziel.classList || !ziel.classList.contains('drawer__content')) return;
    pruefen(ziel);
  }, { capture: true, passive: true });

  /* Nach Neuzeichnen oder Oeffnen steht der Inhalt wieder oben */
  document.documentElement.addEventListener('cart:updated', function () {
    document.querySelectorAll('.dn-cart-v2').forEach(function (drawer) {
      var bereich = drawer.querySelector('.drawer__content');
      drawer.classList.toggle('dn-scrolled', !!bereich && bereich.scrollTop > 4);
    });
  });
})();

/* ------------------------------------------------------------------
   Ein Satz geht immer ganz.

   Das neue Starter Set legt jede Position einzeln in den Warenkorb:
   Designs mit `_discountAmount`, die Zugaben mit `_bundled-free`. Wer
   daraus eine Zeile entfernt, haette sonst entweder Designs mit einem
   Satzrabatt ohne Satz oder — schlimmer — die Zugaben gratis behalten.
   Deshalb nimmt das X an einer Satzzeile alle Zeilen desselben Satzes
   mit, in einem Aufruf. Seit der Set-Karte (snippets/dn-cart-set.liquid)
   sitzt das X am Satz selbst (.dn-set__x); Einzelzeilen mit data-dn-set
   bleiben als Rueckfall dabei.
   ------------------------------------------------------------------ */
(function () {
  var laeuft = false;

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    var knopf = ziel && ziel.closest ? ziel.closest('.cart_title_remove_icon, .line-item__remove-button, .dn-set__x') : null;
    if (!knopf) return;

    var zeile = knopf.closest('line-item[data-dn-set], .dn-set[data-dn-set]');
    if (!zeile || !zeile.closest('.dn-cart-v2')) return;
    /*
      Freie Saetze (Farbwaehler der Einzelproduktseite) gehen Zeile fuer
      Zeile: die Staffel rechnet der Abgleich unten neu. Nur Saetze mit
      Zugaben oder eigener Preislogik gehen ganz.
    */
    if (zeile.hasAttribute('data-dn-set-frei')) return;

    var satz = zeile.getAttribute('data-dn-set');
    if (!satz) return;

    /* Vor dem Theme-Griff abbiegen, sonst entfernt der nur diese eine Zeile */
    ereignis.preventDefault();
    ereignis.stopPropagation();
    ereignis.stopImmediatePropagation();
    if (laeuft) return;

    var geschwister = document.querySelectorAll('.dn-cart-v2 line-item[data-dn-set="' + satz + '"], .dn-cart-v2 .dn-set[data-dn-set="' + satz + '"]');
    for (var i = 0; i < geschwister.length; i++) geschwister[i].classList.add('dn-satz-geht');

    laeuft = true;
    /*
      Die Zeilen kommen aus /cart.js, nicht aus dem DOM: beim alten Set
      stecken die Designs als Kaertchen in der Elternzeile und haben gar
      kein eigenes <line-item>. Wer nur die sichtbaren Zeilen entfernt,
      laesst sie mit vollem Preis im Warenkorb stehen (gemessen).
      Alte Saetze fuehren die Kennung in `_set`, neue in `_set_id`.
    */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (warenkorb) {
        var aenderungen = {};
        var anzahl = 0;
        (warenkorb.items || []).forEach(function (posten) {
          var eig = posten.properties || {};
          if (eig._set === satz || eig._set_id === satz) {
            aenderungen[posten.key] = 0;
            anzahl++;
          }
        });
        if (!anzahl) throw new Error('keine Zeile zu Satz ' + satz);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: aenderungen })
        });
      })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('update.js ' + antwort.status);
        return antwort.json();
      })
      .then(function (warenkorb) {
        /* Ohne Schublade (z. B. /cart) reicht ein Neuladen */
        if (!document.querySelector('#mini-cart')) {
          window.location.reload();
          return;
        }
        var meine = window.dnCartRenderAnfrage = (window.dnCartRenderAnfrage || 0) + 1;
        return fetch('/?section_id=mini-cart')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (meine !== window.dnCartRenderAnfrage) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var alt = document.querySelector('#mini-cart');
            var neu = tmp.querySelector('#mini-cart');
            if (alt && neu) {
              window.dnCartRenderVersion = (window.dnCartRenderVersion || 0) + 1;
              alt.innerHTML = neu.innerHTML;
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: warenkorb }
            }));
          });
      })
      .catch(function (fehler) {
        console.error('Satz konnte nicht entfernt werden:', fehler);
        for (var j = 0; j < geschwister.length; j++) geschwister[j].classList.remove('dn-satz-geht');
      })
      .finally(function () { laeuft = false; });
  }, true);
})();

/* ------------------------------------------------------------------
   Takt wechseln und Mengenstaffel warenkorbweit halten.

   Die Einzelproduktseite gibt eine Staffel nach Zahl der Designs (1..8 ->
   0, 5, 10, 15, 17, 20, 22, 25 %; Abo = Staffel + 10 Punkte, mindestens
   15 %), rechnet sie aber nur fuer die Auswahl auf der Seite. Hier wird sie
   fuer den ganzen Warenkorb nachgezogen: alle zaehlenden Design-Zeilen (auch
   die vom normalen Kaufknopf und von anderen Produktseiten) ergeben die
   Anzahl, und jede freie Zeile bekommt den Abzug dieser Stufe - im
   Einmalkauf als `_discountAmount` (die Bundle-Funktion des Shops wendet
   ihn an, gemessen: 21,95 mit 1,10 steht als 20,85 im Warenkorb), im Abo
   als Loop-Plan der Stufe mit demselben Takt. Was zaehlt und was frei ist,
   sagt das Manifest aus snippets/dn-cart-staffel.liquid; Starter Sets,
   Mix & Match und Geschenke stehen dort gesperrt.

   Ausgeloest wird der Abgleich durch jedes Neuzeichnen der Schublade (das
   Theme zeichnet nach jeder Aenderung neu), es laeuft immer nur ein
   Durchgang, und er endet, sobald das Manifest nichts mehr zu aendern
   laesst. Solange er laeuft, ist der Kaufknopf gesperrt, damit niemand mit
   einer alten Stufe in den Checkout geht.
   ------------------------------------------------------------------ */
(function () {
  var laeuft = false;
  var nochmal = false;
  var timer = null;

  function manifest() {
    var el = document.querySelector('#mini-cart [data-dn-staffel]');
    if (!el) return null;
    try {
      return { aktiv: el.getAttribute('data-dn-staffel-aktiv') === 'true', zeilen: JSON.parse(el.textContent) };
    } catch (e) { return null; }
  }
  function staffel(n) {
    if (n >= 8) return 0.25;
    if (n >= 7) return 0.22;
    if (n >= 6) return 0.20;
    if (n >= 5) return 0.17;
    if (n >= 4) return 0.15;
    if (n >= 3) return 0.10;
    if (n >= 2) return 0.05;
    return 0;
  }
  function abo(d) { return d > 0 ? d + 0.10 : 0.15; }

  function aendern(body, versuch) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      /* zu viele Anfragen auf einmal: einmal kurz warten und wiederholen */
      if (r.status === 429 && !versuch) {
        return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return aendern(body, 1); });
      }
      if (!r.ok) throw new Error('change.js ' + r.status);
      return r.json();
    });
  }
  function neuZeichnen(warenkorb) {
    /* Zaehler gegen Ueberholen: das Theme zeichnet nach cart:refresh per
       Fetch, der Abgleich kurz danach noch einmal - kommt die aeltere Antwort
       spaeter an, zeigte die Schublade Zeilen mit toten Schluesseln. */
    var meine = window.dnCartRenderAnfrage = (window.dnCartRenderAnfrage || 0) + 1;
    var wk = warenkorb ? Promise.resolve(warenkorb)
      : fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    return wk.then(function (c) { warenkorb = c; return fetch('/?section_id=mini-cart'); })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (meine !== window.dnCartRenderAnfrage) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var alt = document.querySelector('#mini-cart');
        var neu = tmp.querySelector('#mini-cart');
        if (alt && neu) {
          window.dnCartRenderVersion = (window.dnCartRenderVersion || 0) + 1;
          alt.innerHTML = neu.innerHTML;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: warenkorb }
        }));
      });
  }
  function sperren(an) {
    document.querySelectorAll('#mini-cart .checkout-button').forEach(function (b) { b.disabled = !!an; });
    /* sichtbare Rueckmeldung, solange Zeilen umgestellt werden (Klasse in dn-cart.css) */
    var mc = document.querySelector('#mini-cart');
    if (mc) mc.classList.toggle('is-dn-busy', !!an);
  }
  window.dnCartNeuZeichnen = neuZeichnen;
  /*
    Aufgaben NACHEINANDER. Gleichzeitig (Versuch 2026-09-07, PR #749) verlor
    Shopify Aenderungen: bei vier parallelen change.js blieb eine Zeile auf dem
    alten Kaufplan, und die einzelnen Anfragen wurden unter Last langsamer
    (0,9 bis 2,4 s statt 0,8 s), der Gewinn war gering (4,7 -> 4,4 s). Der
    Warenkorb wird je Anfrage als Ganzes gelesen und geschrieben, verschiedene
    Zeilen schuetzen nicht. Ein Fehler an einer Zeile bricht die uebrigen nicht
    ab (gemessen: ein 400 an der ersten Zeile liess alle weiteren
    ungerabattiert). Ergebnis: letzter Warenkorb (bei Reihenfolge der Endstand),
    Zahl der Fehler.
  */
  function nacheinander(aufgaben) {
    var stand = { warenkorb: null, fehler: 0, ok: 0 };
    return aufgaben.reduce(function (kette, a) {
      return kette.then(function () {
        return aendern(a).then(function (c) { stand.warenkorb = c; stand.ok++; })
          .catch(function (fehler) { stand.fehler++; console.warn('Warenkorbzeile nicht geaendert:', a.id, fehler.message); });
      });
    }, Promise.resolve()).then(function () { return stand; });
  }

  /*
    ---------- Stapel ueber die Storefront API ----------
    Die Cart-API aendert je change.js nur EINE Zeile (~0,8 s Serverzeit); zehn
    Abo-Zeilen brauchten fuer einen Taktwechsel 5-8 s (Roman, 2026-09-07).
    Parallel geht nicht (verlorene Aenderungen, #751), add.js im Stapel
    feuert je Zeile ein product_added_to_cart-Pixel. Die Storefront API stellt
    mit cartLinesUpdate alle Zeilen in EINEM Aufruf um, ohne Pixel-Ereignisse;
    der Warenkorb der Cart-API ist dort als gid://shopify/Cart/<token>
    erreichbar. Braucht den oeffentlichen Storefront-Token aus dem Feld
    "Storefront API token" am Cart-Drawer-Abschnitt (data-dn-sf-token an
    #mini-cart). Ohne Token, bei nur einer Aufgabe, bei Kaufplan null
    (Einmalkauf) oder bei jedem Fehler: Zeile fuer Zeile wie bisher. Die
    Zeilen der Storefront API werden den Cart-API-Schluesseln zugeordnet:
    erst ueber den Schluessel in der Zeilen-ID, sonst ueber Variante,
    Kaufplan, Menge und Eigenschaften. cartLinesUpdate ist ganz oder gar
    nicht, ein Teilstand kann nicht entstehen.
  */
  var SF_VERSION = '2026-01';
  function sfToken() {
    var mc = document.querySelector('#mini-cart');
    return mc ? (mc.getAttribute('data-dn-sf-token') || '').trim() : '';
  }
  function sfAbfrage(token, query, variables) {
    return fetch('/api/' + SF_VERSION + '/graphql.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('storefront ' + r.status);
      return r.json();
    }).then(function (j) {
      if (j.errors && j.errors.length) throw new Error(j.errors[0].message);
      return j.data;
    });
  }
  function eigenschaftenGleich(attrs, props) {
    var a = {}; (attrs || []).forEach(function (x) { a[x.key] = String(x.value); });
    var b = {}; Object.keys(props || {}).forEach(function (k) { b[k] = String(props[k]); });
    var ka = Object.keys(a).sort(), kb = Object.keys(b).sort();
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) { if (ka[i] !== kb[i] || a[ka[i]] !== b[kb[i]]) return false; }
    return true;
  }
  function stapel(aufgaben) {
    var token = sfToken();
    var geeignet = token && aufgaben.length >= 2 && aufgaben.every(function (a) { return a.selling_plan !== null; });
    if (!geeignet) return nacheinander(aufgaben);
    var stand = { warenkorb: null, fehler: 0, ok: 0 };
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var zeilen = {};
        (cart.items || []).forEach(function (i) { zeilen[i.key] = i; });
        var cartId = 'gid://shopify/Cart/' + cart.token;
        var abfrage = 'query($id: ID!) { cart(id: $id) { id lines(first: 250) { nodes { id quantity merchandise { ... on ProductVariant { id } } sellingPlanAllocation { sellingPlan { id } } attributes { key value } } } } }';
        return sfAbfrage(token, abfrage, { id: cartId }).then(function (data) {
          if (!data || !data.cart) throw new Error('Warenkorb ueber die Storefront API nicht erreichbar');
          var knoten = (data.cart.lines && data.cart.lines.nodes || []).slice();
          var lines = [];
          aufgaben.forEach(function (a) {
            var z = zeilen[a.id];
            if (!z) { stand.fehler++; console.warn('Warenkorbzeile nicht mehr da:', a.id); return; }
            var treffer = null;
            for (var i = 0; i < knoten.length; i++) {
              if (knoten[i].id.indexOf('/CartLine/' + a.id) > -1) { treffer = knoten[i]; break; }
            }
            if (!treffer) {
              var varGid = 'gid://shopify/ProductVariant/' + z.variant_id;
              var planGid = z.selling_plan_allocation ? 'gid://shopify/SellingPlan/' + z.selling_plan_allocation.selling_plan.id : null;
              for (var j = 0; j < knoten.length; j++) {
                var n = knoten[j];
                var nPlan = n.sellingPlanAllocation && n.sellingPlanAllocation.sellingPlan ? n.sellingPlanAllocation.sellingPlan.id : null;
                if (n.merchandise && n.merchandise.id === varGid && nPlan === planGid && n.quantity === z.quantity && eigenschaftenGleich(n.attributes, z.properties)) { treffer = n; break; }
              }
            }
            if (!treffer) throw new Error('Zeile nicht zugeordnet: ' + a.id);
            knoten.splice(knoten.indexOf(treffer), 1);
            var line = { id: treffer.id, quantity: a.quantity != null ? a.quantity : z.quantity };
            if (a.selling_plan) line.sellingPlanId = 'gid://shopify/SellingPlan/' + a.selling_plan;
            else if (z.selling_plan_allocation) line.sellingPlanId = 'gid://shopify/SellingPlan/' + z.selling_plan_allocation.selling_plan.id;
            var props = a.properties !== undefined ? a.properties : (z.properties || {});
            line.attributes = Object.keys(props || {}).filter(function (k) { return String(props[k]) !== ''; }).map(function (k) { return { key: k, value: String(props[k]) }; });
            lines.push(line);
          });
          if (!lines.length) return stand;
          var mutation = 'mutation($id: ID!, $lines: [CartLineUpdateInput!]!) { cartLinesUpdate(cartId: $id, lines: $lines) { cart { id } userErrors { field message } } }';
          return sfAbfrage(token, mutation, { id: cartId, lines: lines }).then(function (d2) {
            var fehler = d2 && d2.cartLinesUpdate ? (d2.cartLinesUpdate.userErrors || []) : [];
            if (fehler.length) throw new Error(fehler[0].message);
            stand.ok = lines.length;
            return stand;
          });
        });
      })
      .catch(function (fehler) {
        console.warn('Stapel ueber die Storefront API nicht moeglich, Zeile fuer Zeile:', fehler.message);
        return nacheinander(aufgaben);
      });
  }

  /*
    Eigenschaften der Zeile als Objekt. Das Manifest liefert ein Objekt;
    kaeme eine Liste von Paaren (so gibt Liquid `properties | json` aus),
    wird sie umgebaut - sonst landen "0", "1", "2" als Schluessel an der
    Zeile (gemessen 2026-09-06).
  */
  function eigenschaften(zeile) {
    var props = {};
    var q = zeile.props || {};
    if (Array.isArray(q)) {
      q.forEach(function (paar) { if (paar && paar.length === 2) props[paar[0]] = paar[1]; });
    } else {
      Object.keys(q).forEach(function (k) { if (!/^\d+$/.test(k)) props[k] = q[k]; });
    }
    return props;
  }

  /*
    change.js ersetzt die Eigenschaften nur, wenn das Objekt nicht leer ist -
    ein leeres {} laesst alles stehen (gemessen: "Subscription Discount"
    blieb nach dem Wechsel auf Einmalkauf). Sollen alle weg, geht eine
    einzige leere, versteckte Eigenschaft mit.
  */
  function propsZumSenden(props) {
    return Object.keys(props).length ? props : { '_dn': '' };
  }

  /*
    Plan der Stufe: gleicher Takt, hoechster Prozentsatz bis zum Ziel.
    Mit `zielWochen` wird der Takt vorgegeben (einheitlicher Takt im ganzen
    Warenkorb, Roman 2026-09-08); kennt die Variante diesen Takt nicht,
    bleibt ihr eigener.
  */
  function planWahl(zeile, zielProz, zielWochen) {
    var akt = null;
    (zeile.plaene || []).forEach(function (p) { if (p.id === zeile.plan) akt = p; });
    var wochen = akt ? akt.wochen : zeile.wochen;
    if (zielWochen && (zeile.plaene || []).some(function (p) { return p.wochen === zielWochen; })) wochen = zielWochen;
    var beste = null;
    (zeile.plaene || []).forEach(function (p) {
      if (p.wochen !== wochen) return;
      if (!(p.proz > 0) || p.proz > zielProz + 0.001) return;
      if (!beste || p.proz > beste.proz) beste = p;
    });
    return beste;
  }

  /*
    Das Manifest kommt aus dem letzten Zeichnen der Schublade und kann
    hinter dem Warenkorb liegen (gemessen: eine Zeile war schon
    umgeschrieben, ihr alter Schluessel stand noch im Manifest, change.js
    antwortete 400, und weil danach nicht neu gezeichnet wurde, lief jeder
    weitere Durchgang in denselben Fehler). Deshalb: vor dem Aendern die
    Zeilen frisch aus /cart.js holen, Aufgaben nur fuer Schluessel, die es
    noch gibt, danach in jedem Fall neu zeichnen. Laeuft gerade die
    Geschenk-Automatik des Themes (window.dnGiftLaeuft), erst danach.
    Hoechstens drei Anlaeufe hintereinander mit Fehlern.
  */
  var fehlversuche = 0;
  function abgleichen() {
    var m = manifest();
    if (!m || !m.aktiv) return;
    if (laeuft) { nochmal = true; return; }
    if (window.dnGiftLaeuft) { planen(400); return; }
    if (fehlversuche >= 3) return;

    var n = 0;
    m.zeilen.forEach(function (z) { if (z.zaehlt) n += z.qty || 0; });
    var d = staffel(n);
    var ziel = Math.round(abo(d) * 100);

    laeuft = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (frisch) {
        var vorhanden = {};
        (frisch.items || []).forEach(function (i) { vorhanden[i.key] = i; });
        /*
          EIN TAKT FUER ALLE ABO-ZEILEN (Roman, 2026-09-08): lag ein Abo mit
          4 Wochen im Warenkorb und kamen Zeilen mit 12 Wochen dazu, blieb das
          alte bei 4 Wochen. /cart.js liefert die Zeilen juengste zuerst; der
          Takt der juengsten Abo-Zeile gilt fuer alle, die ihn kennen.
        */
        var zielWochen = null;
        (frisch.items || []).some(function (i) {
          var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
          if (!sp || !sp.name) return false;
          var w = String(sp.name).split('every ').pop().split(' ')[0];
          if (/^\d+$/.test(w)) { zielWochen = w; return true; }
          return false;
        });
        var veraltet = false;
        var aufgaben = [];
        m.zeilen.forEach(function (z) {
          if (!z.frei) return;
          var aktuell = vorhanden[z.key];
          if (!aktuell) { veraltet = true; return; }
          var props = eigenschaften({ props: aktuell.properties || {} });
          var abzug = parseFloat(props['_discountAmount']) || 0;
          var planId = aktuell.selling_plan_allocation ? aktuell.selling_plan_allocation.selling_plan.id : 0;
          if (planId) {
            /* Abo-Zeilen tragen keinen Einmalkauf-Abzug - sonst Rabatt doppelt (Plan und Bundle Discount) */
            var doppelt = props['_discountAmount'] !== undefined || props['_bundled-product'] !== undefined;
            var p = planWahl({ plan: planId, plaene: z.plaene, wochen: z.wochen }, ziel, zielWochen);
            var neuerPlan = p && p.id !== planId ? p : null;
            if (!neuerPlan && !doppelt) return;
            delete props['_discountAmount'];
            delete props['_bundled-product'];
            if (neuerPlan && props['Subscription Discount'] !== undefined) props['Subscription Discount'] = Math.round(neuerPlan.proz) + '%';
            aufgaben.push({ id: z.key, quantity: aktuell.quantity, selling_plan: neuerPlan ? neuerPlan.id : planId, properties: propsZumSenden(props) });
          } else {
            /* Einmalkauf-Zeilen tragen keinen Abo-Vermerk (bleibt sonst nach dem Wechsel stehen) */
            var vermerk = props['Subscription Discount'] !== undefined;
            delete props['Subscription Discount'];
            /*
              _discountAmount gilt fuer die GANZE Zeile, nicht je Stueck
              (gemessen 2026-09-08: 1,69 auf zwei Pockets = 169 Cent Abzug,
              3,38 = 338). Also Abzug je Stueck mal Menge - sonst bekam ein
              doppelt gewaehltes Produkt nur den halben Rabatt.
            */
            var stueck = d > 0 ? Math.round(z.preis * d) : 0;
            var soll = stueck > 0 ? Math.round(stueck * (aktuell.quantity || z.qty || 1)) / 100 : 0;
            if (Math.abs(soll - abzug) < 0.005 && !vermerk) return;
            if (soll > 0) {
              props['_bundled-product'] = true;
              props['_discountAmount'] = soll;
            } else {
              delete props['_bundled-product'];
              delete props['_discountAmount'];
            }
            aufgaben.push({ id: z.key, quantity: aktuell.quantity, properties: propsZumSenden(props) });
          }
        });
        if (!aufgaben.length) {
          /* Manifest hinkt dem Warenkorb hinterher: einmal frisch zeichnen */
          if (veraltet) return neuZeichnen(frisch).then(function () { return { fehler: 0, ok: 0, veraltet: true }; });
          return { fehler: 0, ok: 0 };
        }
        sperren(true);
        return stapel(aufgaben).then(function (stand) {
          return neuZeichnen(stand.warenkorb || null).then(function () { return stand; });
        });
      })
      .then(function (stand) {
        if (stand && stand.fehler) { fehlversuche++; nochmal = true; }
        else if (stand && stand.ok) { fehlversuche = 0; }
      })
      .catch(function (fehler) { console.error('Staffel im Warenkorb:', fehler); fehlversuche++; })
      .then(function () {
        laeuft = false;
        sperren(false);
        if (nochmal) { nochmal = false; planen(fehlversuche ? 1200 : 250); }
      });
  }
  function planen(wartezeit) {
    clearTimeout(timer);
    timer = setTimeout(abgleichen, wartezeit || 250);
  }

  var wurzel = document.querySelector('#mini-cart');
  if (wurzel) {
    new MutationObserver(planen).observe(wurzel, { childList: true, subtree: true });
    planen();
  }

  /* ---------- Takt ----------
     Ein Taktwechsel gilt fuer alle Abo-Zeilen im Warenkorb: jede Zeile
     bekommt den Plan ihrer eigenen Gruppe mit dem gewaehlten Takt (die
     Gruppen unterscheiden sich je Stufe und je Set, die Kennungen also
     auch). Sonst bekaeme der Kunde getrennte Lieferungen. "One-time
     purchase" nimmt dagegen nur dieser einen Zeile den Kaufplan und den
     Abo-Vermerk; den Staffelrabatt setzt der Abgleich danach. */
  document.addEventListener('change', function (ereignis) {
    var sel = ereignis.target && ereignis.target.closest ? ereignis.target.closest('[data-dn-takt]') : null;
    if (!sel) return;
    var m = manifest();
    var key = sel.getAttribute('data-dn-takt-key') || '';
    var aufgaben = [];

    if (sel.value === 'einmal') {
      var zeile = null;
      if (m) m.zeilen.forEach(function (z) { if (z.key === key) zeile = z; });
      var props = zeile ? eigenschaften(zeile) : null;
      if (props) delete props['Subscription Discount'];
      var auftrag = { id: key, quantity: zeile ? zeile.qty : 1, selling_plan: null };
      if (props) auftrag.properties = propsZumSenden(props);
      aufgaben.push(auftrag);
    } else if (sel.value === 'abo') {
      /*
        Zurueck ins Abo: Plan der aktuellen Staffelstufe mit dem gewaehlten
        Takt (Anzahl aus dem Manifest, wie im Abgleich), Einmalkauf-Abzug
        weg, Abo-Vermerk wie beim Farbwaehler. Danach laufen die uebrigen
        Abo-Zeilen auf denselben Takt.
      */
      if (!m) return;
      var optAbo = sel.options[sel.selectedIndex];
      var wochenAbo = optAbo ? optAbo.getAttribute('data-dn-wochen') : '';
      var zeileAbo = null;
      m.zeilen.forEach(function (z) { if (z.key === key) zeileAbo = z; });
      if (!zeileAbo || !wochenAbo) return;
      var nAbo = 0;
      m.zeilen.forEach(function (z) { if (z.zaehlt) nAbo += z.qty || 0; });
      var zielAbo = Math.round(abo(staffel(nAbo)) * 100);
      var planAbo = planWahl({ plan: 0, plaene: zeileAbo.plaene, wochen: wochenAbo }, zielAbo);
      if (!planAbo) { console.warn('Kein Abo-Plan fuer Takt', wochenAbo); sel.value = 'einmal'; return; }
      var propsAbo = eigenschaften(zeileAbo);
      delete propsAbo['_discountAmount'];
      delete propsAbo['_bundled-product'];
      propsAbo['Subscription Discount'] = Math.round(planAbo.proz) + '%';
      aufgaben.push({ id: key, quantity: zeileAbo.qty, selling_plan: planAbo.id, properties: propsAbo });
      m.zeilen.forEach(function (z) {
        if (!z.plan || z.key === key) return;
        var akt = null;
        (z.plaene || []).forEach(function (p) { if (p.id === z.plan) akt = p; });
        var ziel = null;
        (z.plaene || []).forEach(function (p) {
          if (akt && p.gruppe !== akt.gruppe) return;
          if (p.wochen === wochenAbo) ziel = p;
        });
        if (ziel && ziel.id !== z.plan) aufgaben.push({ id: z.key, quantity: z.qty, selling_plan: ziel.id });
      });
    } else {
      var opt = sel.options[sel.selectedIndex];
      var wochen = opt ? opt.getAttribute('data-dn-wochen') : '';
      var planId = parseInt(sel.value, 10);
      if (!planId || !m) return;
      m.zeilen.forEach(function (z) {
        if (!z.plan) return;
        var akt = null;
        (z.plaene || []).forEach(function (p) { if (p.id === z.plan) akt = p; });
        var ziel = null;
        (z.plaene || []).forEach(function (p) {
          if (akt && p.gruppe !== akt.gruppe) return;
          if (p.wochen === wochen) ziel = p;
        });
        if (!ziel && z.key === key) ziel = { id: planId };
        if (ziel && ziel.id !== z.plan) aufgaben.push({ id: z.key, quantity: z.qty, selling_plan: ziel.id });
      });
    }
    if (!aufgaben.length) return;

    /* Sofortige Rueckmeldung: die Auswahlfelder der anderen Abo-Zeilen zeigen
       den neuen Takt, bevor die Anfragen durch sind (je Zeile ~0,8 s, nacheinander). */
    var wochenNeu = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].getAttribute('data-dn-wochen') : '';
    if (wochenNeu && sel.value !== 'einmal') {
      document.querySelectorAll('#mini-cart [data-dn-takt]').forEach(function (anderes) {
        if (anderes === sel) return;
        var passt = Array.prototype.filter.call(anderes.options, function (o) { return o.getAttribute('data-dn-wochen') === wochenNeu && o.value !== 'abo'; })[0];
        if (passt) { anderes.value = passt.value; anderes.disabled = true; }
      });
    }
    sel.disabled = true;
    laeuft = true;
    sperren(true);
    stapel(aufgaben)
      .then(function (stand) {
        if (stand.fehler) console.error('Takt: ' + stand.fehler + ' Zeile(n) nicht gewechselt');
        return neuZeichnen(stand.warenkorb || null);
      })
      .catch(function (fehler) {
        console.error('Takt konnte nicht gewechselt werden:', fehler);
        sel.disabled = false;
      })
      .then(function () {
        laeuft = false;
        sperren(false);
        planen();
      });
  }, true);
})();

/* ------------------------------------------------------------------
   Freie Saetze gehen Zeile fuer Zeile.

   Das Theme (theme.js, checkBundleQytChange) nullt bei JEDER
   Mengenaenderung an einer Zeile mit `_set`/`_set_id` alle Zeilen des
   Satzes - auch beim Schritt von 1 auf 2. Fuer Starter Set und Mix & Match
   ist das gewollt, fuer die Saetze des Farbwaehlers der Einzelproduktseite
   nicht mehr: ihr Rabatt ist seit der warenkorbweiten Staffel eine
   Rechnung ueber den ganzen Warenkorb, nicht mehr ueber den Satz (gemessen:
   das X an einer von zwei Zeilen nahm beide mit). Deshalb fangen X und
   Mengenwahl an Zeilen mit data-dn-set-frei hier ab und aendern nur diese
   eine Zeile; die Staffel rechnet der Abgleich oben danach neu.
   ------------------------------------------------------------------ */
(function () {
  function freieZeile(el) {
    var li = el && el.closest ? el.closest('line-item[data-dn-set-frei]') : null;
    return li && li.closest('.dn-cart-v2') ? li : null;
  }
  function aendern(key, menge) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: menge })
    }).then(function (r) {
      if (!r.ok) throw new Error('change.js ' + r.status);
      return r.json();
    });
  }
  function fertig(warenkorb) {
    if (typeof window.dnCartNeuZeichnen === 'function') return window.dnCartNeuZeichnen(warenkorb);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: warenkorb } }));
  }
  /* Der Schluessel im DOM kann veraltet sein: der Abgleich schreibt Properties
     (Staffel, Kaufplan) und damit neue Schluessel, und zwei Neuzeichnungen
     (Theme nach cart:refresh, Abgleich danach) koennen sich kreuzen. Ein Klick
     mit altem Schluessel lief ins Leere und die Zeile blieb stehen (Roman,
     2026-09-06). Deshalb vor jeder Aenderung den aktuellen Schluessel aus
     /cart.js holen: gleicher Schluessel, sonst gleiche Variante im gleichen
     Satz. Nichts gefunden heisst: die Zeile ist schon weg, nur neu zeichnen. */
  function frischerKey(li) {
    var domKey = li.getAttribute('data-key') || '';
    var satz = li.getAttribute('data-dn-set') || '';
    var variante = parseInt(domKey, 10);
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = (c && c.items) || [];
        for (var i = 0; i < items.length; i++) if (items[i].key === domKey) return items[i].key;
        for (var j = 0; j < items.length; j++) {
          var it = items[j];
          if (it.variant_id === variante && (!satz || (it.properties && String(it.properties._set_id) === satz))) return it.key;
        }
        return null;
      });
  }

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    var knopf = ziel && ziel.closest ? ziel.closest('.cart_title_remove_icon, .line-item__remove-button') : null;
    if (!knopf) return;
    var li = freieZeile(knopf);
    if (!li) return;
    var key = li.getAttribute('data-key');
    if (!key) return;
    ereignis.preventDefault();
    ereignis.stopPropagation();
    ereignis.stopImmediatePropagation();
    li.classList.add('dn-satz-geht');
    frischerKey(li).then(function (frisch) {
      if (!frisch) return fertig();
      return aendern(frisch, 0).then(fertig);
    }).catch(function (fehler) {
      console.error('Zeile konnte nicht entfernt werden:', fehler);
      li.classList.remove('dn-satz-geht');
    });
  }, true);

  document.addEventListener('change', function (ereignis) {
    var feld = ereignis.target;
    if (!feld || !feld.matches || !feld.matches('line-item-quantity select, line-item-quantity input')) return;
    var li = freieZeile(feld);
    if (!li) return;
    var key = li.getAttribute('data-key');
    var menge = parseInt(feld.value, 10);
    if (!key || isNaN(menge) || menge < 0) return;
    ereignis.stopPropagation();
    ereignis.stopImmediatePropagation();
    feld.disabled = true;
    frischerKey(li).then(function (frisch) {
      if (!frisch) return fertig();
      return aendern(frisch, menge).then(fertig);
    }).catch(function (fehler) {
      console.error('Menge konnte nicht geaendert werden:', fehler);
      feld.disabled = false;
    });
  }, true);
})();

/* ------------------------------------------------------------------
   Sichtbare Anzahl in der Kopf-Blase.

   Das Theme schreibt nach jeder Aenderung `cart.item_count` in die
   <cart-count>-Blasen - bei einem Starter Set also fuenf statt eins. Die
   Schublade rendert die sichtbare Anzahl schon serverseitig
   (snippets/dn-cart-anzahl.liquid); hier dieselbe Regel fuer die Blasen im
   Kopf und im LP-Kopf, ausgeloest von denselben Ereignissen. Dieses Skript
   laedt nach theme.js, seine Zuhoerer laufen deshalb nach denen des Themes
   und ueberschreiben dessen Zahl.
   ------------------------------------------------------------------ */
(function () {
  function istEltern(p) {
    if (p['_bundle-parent'] || p['_starter-set-parent'] || p['_refill-bundle-parent'] || p['_childItemsJson']) return true;
    return Object.keys(p).some(function (k) { return k.indexOf('_variants_set') > -1 || k.indexOf('_free_variants') > -1; });
  }
  function sichtbareAnzahl(cart) {
    var items = (cart && cart.items) || [];
    var eltern = {}, starter = {};
    items.forEach(function (i) {
      var p = i.properties || {};
      var satz = p._set_id || p._set || '';
      if (!satz) return;
      if (istEltern(p)) eltern[satz] = true;
      else if (p._set_handle || p._onetime_tag || p._subscription_tag) starter[satz] = true;
    });
    var n = 0, gezaehlt = {};
    items.forEach(function (i) {
      var p = i.properties || {};
      var satz = p._set_id || p._set || '';
      if (istEltern(p)) { n += i.quantity || 0; return; }
      if (p['_bundled-collection']) return;
      if (satz && eltern[satz]) return;
      if (satz && starter[satz]) { if (!gezaehlt[satz]) { gezaehlt[satz] = true; n += 1; } return; }
      n += i.quantity || 0;
    });
    return n;
  }
  function schreiben(n) {
    document.querySelectorAll('cart-count').forEach(function (el) { el.innerText = n; });
    document.querySelectorAll('[data-dn-lp-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function setzen(cart) {
    if (cart && cart.items) {
      schreiben(sichtbareAnzahl(cart));
      return;
    }
    /* Ohne Warenkorb im Ereignis holt auch das Theme /cart.js und schreibt
       item_count, sobald es antwortet - deshalb hier nach der Antwort und
       noch einmal kurz danach. */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = sichtbareAnzahl(c);
        schreiben(n);
        setTimeout(function () { schreiben(n); }, 800);
      })
      .catch(function () {});
  }
  ['cart:updated', 'cart:refresh'].forEach(function (name) {
    document.documentElement.addEventListener(name, function (e) { setzen(e && e.detail && e.detail.cart); });
  });
  window.dnSichtbareAnzahl = sichtbareAnzahl;
})();
